import { Facebook, Instagram, Youtube, Music2, Ghost } from "lucide-react";

const SOCIALS = [
  { id: "facebook", label: "Facebook", href: "https://facebook.com/tekreck", icon: Facebook, handle: "/tekreck" },
  { id: "instagram", label: "Instagram", href: "https://instagram.com/camerasalwaysrollin", icon: Instagram, handle: "/camerasalwaysrollin" },
  { id: "snapchat", label: "Snapchat", href: "https://snapchat.com/add/tekreck", icon: Ghost, handle: "@tekreck" },
  { id: "spotify", label: "Spotify", href: "https://open.spotify.com/artist/7x9ldSU6voBZpcHMNOGVlw", icon: Music2, handle: "Tekreck" },
  { id: "youtube", label: "YouTube", href: "https://www.youtube.com/@tekreck", icon: Youtube, handle: "@tekreck" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative bg-black border-t border-white/10 pt-24 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="h-2 w-2 rounded-full bg-[#D4AF37]" />
              <span className="font-display font-black tracking-[0.3em] text-sm">
                TEKRECK
              </span>
            </div>
            <p className="font-display text-2xl md:text-3xl tracking-tight leading-tight max-w-md">
              Music, ministry, and the long road home.
            </p>
            <p className="mt-6 text-sm text-white/50 max-w-md leading-relaxed">
              Jesus is Lord. Healing is real. The gifts of the Spirit are for
              today. If you need prayer, reach out. If you want to collab,
              let's build.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-5">
              Find me
            </div>
            <ul className="space-y-3">
              {SOCIALS.map(({ id, label, href, icon: Icon, handle }) => (
                <li key={id}>
                  <a
                    data-testid={`social-link-${id}`}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className="group flex items-center justify-between py-2 border-b border-white/5 hover:border-[#D4AF37]/60 transition-colors"
                  >
                    <span className="flex items-center gap-3">
                      <Icon size={16} className="text-white/60 group-hover:text-[#D4AF37] transition-colors" />
                      <span className="text-sm">{label}</span>
                    </span>
                    <span className="text-xs text-white/40 group-hover:text-white/80 transition-colors">
                      {handle}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-5">
              Quick Links
            </div>
            <ul className="space-y-3 text-sm">
              {["music", "recent", "faith", "collab", "prayer"].map((x) => (
                <li key={x}>
                  <a
                    data-testid={`footer-link-${x}`}
                    href={`#${x}`}
                    className="text-white/60 hover:text-[#D4AF37] transition-colors capitalize"
                  >
                    {x}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Marquee */}
        <div className="overflow-hidden border-y border-white/10 py-6 mb-10">
          <div className="flex whitespace-nowrap marquee-track">
            {Array(6).fill("TEKRECK · LUKE 4:18 · HOLY GHOST FIRE · JESUS IS KING · HEALING IS REAL · ").join("").split(" · ").map((word, i) => (
              word && (
                <span key={i} className="font-display font-black text-4xl md:text-5xl mx-6 text-white/10 tracking-tighter">
                  {word}
                </span>
              )
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Tekreck. All rights reserved.</div>
          <div className="uppercase tracking-[0.3em]">Soli Deo Gloria</div>
        </div>
      </div>
    </footer>
  );
};
